import { __assign } from "tslib";
import { get } from 'lodash';
import { RegionType } from '@wix/shoutout-email-model-v3';
import { extractTextStyles, getSecondaryButton } from '../../utils/elements';
import { calculateLineHeightInPx } from '../../utils/inject-mobile-line-height-class';
import { defaultLineHeight, defaultTextSize } from '../../utils/defaults';
import { getContentWidth } from '../../utils/get-message-width';
import * as cssUtils from '../../utils/css-utils';
// not a good location for this function
var titleClassName = 'so-global-h3';
export var getSubscribeSection = function (_a) {
    var css = _a.css, isRtl = _a.isRtl, region = _a.region, composerData = _a.composerData;
    if (region.type !== RegionType.Subscribe) {
        throw Error('Subscribe must be passed');
    }
    var trimText = function (text, length) { return text.substring(0, length); };
    var defaultTitleStyle = get(css, titleClassName) || {};
    var customTitleStyle = get(region, 'data.styles.title') || {};
    // 18 seems to be a save maximum amount of character we can show
    // in one column on mobile.
    var maxCharsPerLine = 18;
    var extractedTextStyles = extractTextStyles(customTitleStyle, defaultTitleStyle);
    var titleStyles = __assign({ lineHeight: calculateLineHeightInPx(defaultTitleStyle.lineHeight || defaultLineHeight, extractedTextStyles.fontSize || defaultTextSize + "px") }, extractedTextStyles);
    function getPlaceholderText() {
        var placeholderText = get(region, 'data.placeholderText', undefined);
        if (placeholderText) {
            return trimText(placeholderText, maxCharsPerLine);
        }
        return undefined;
    }
    var p1Style = get(css, 'so-global-p1', {});
    var consentTextStyle = Object.keys(p1Style).reduce(function (result, prop) {
        if (p1Style[prop]) {
            result[prop] = p1Style[prop];
        }
        return result;
    }, {});
    var rules = [css['so-global-region-subscribe'], css['so-global-region']];
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules);
    var margin = cssUtils.margin(rules);
    var padding = cssUtils.padding(rules);
    var titleOuterPadding = __assign(__assign({}, margin), { bottom: 0 });
    var titleInnerPadding = __assign(__assign({}, padding), { bottom: 15 });
    var titleCssClass = cssUtils.getTopPaddingRestrictionCssClass(rules);
    var formOuterPadding = __assign(__assign({}, margin), { top: 0 });
    var formInnerPadding = __assign(__assign({}, padding), { top: 0 });
    var formCssClass = cssUtils.getBottomPaddingRestrictionCssClass(rules);
    var contentWidth = getContentWidth(composerData, css, rules) -
        (padding.left || 0) -
        (padding.right || 0);
    var columnsWidths = cssUtils
        .calculateColumnsProportions(contentWidth, [70, 30], padding, isRtl)
        .map(function (val) { return val + "%"; });
    return {
        widthsForMediaQueries: columnsWidths,
        button: getSecondaryButton(css, get(region, 'data.styles.button', {}), trimText(region.data.buttonText, maxCharsPerLine), region.trackedLinkToRegion),
        title: __assign(__assign({}, titleStyles), { text: region.data.title }),
        consent: {
            shouldRequireConsent: get(region, 'data.shouldRequireConsent', false),
            consentCheckboxText: region.data.consentCheckboxText,
            shouldShowConsentLink: region.data.shouldShowConsentLink,
            consentLinkText: region.data.consentLinkText,
            consentLinkUrl: region.data.consentLinkUrl,
            consentTextStyle: consentTextStyle,
        },
        placeholderText: getPlaceholderText(),
        titleOuterPadding: titleOuterPadding,
        titleInnerPadding: titleInnerPadding,
        formOuterPadding: formOuterPadding,
        formInnerPadding: formInnerPadding,
        cssClass: mobileCssClass,
        titleCssClass: titleCssClass,
        formCssClass: formCssClass,
        columnsWidths: columnsWidths,
        successMessage: region.data.successMessage,
        errorMessage: region.data.errorMessage,
    };
};
//# sourceMappingURL=get-subscribe-section.js.map